<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:37:17
-->
<template>
  <div class="custom-pie">
    <div class="custom-pie-item">
      <svg class="svg" width="500" :height="svgHeight" viewport="0 0 400 360">
        <g class="svg-content">
          <ellipse
            class="shodow shodow-1"
            :cx="a"
            :cy="b"
            :rx="a"
            :ry="b"
            fill="#C9D0DF"
          />
          <ellipse
            class="shodow shodow-2"
            :cx="a"
            :cy="b"
            :rx="a"
            :ry="b"
            fill="#E5EDFF"
          />
          <g
            v-for="(item, index) in pathArr"
            :key="`a${index}`"
            @mouseenter="$set(pathHover, index, true)"
            @mouseleave="$set(pathHover, index, false)"
          >
            <path
              class="custom-pie-item-block"
              v-for="(v, k) in item.surfaces"
              :key="k"
              :d="v"
              :fill="
                colorArr[item.index % 6](
                  (k == 'top' ? 1 : k == 'back' ? 0.8 : 0.6) -
                    (pathHover[index] ? 0.1 : 0)
                )
              "
              stroke="red"
              stroke-width="0"
              :data-v="v"
              :data-k="k"
            />
            <pieLineText
              :series0data="dealSeries0data"
              v-if="dealSeries0data[index].value > 0"
              :pointPath="item.point.path"
              :point="item.point.o"
              :label="
                `${item.info.name}${item.info.b ? '：' + item.info.b : ''}`
              "
              :a="a"
              :b="b"
              :index="item.index"
              :icon="colorArr[item.index % 6](1)"
            />
          </g>
          <g class="surface-shadow">
            <g
              v-for="(item, index) in pathArr2"
              :key="index"
              @mouseenter="$set(pathHover, index, true)"
              @mouseleave="$set(pathHover, index, false)"
            >
              <path
                class="custom-pie-item-block"
                v-for="(v, k) in item.surfaces"
                :key="`s${k}`"
                :d="v"
                fill="rgba(255,255,255,.1)"
                stroke="red"
                stroke-width="0"
                :data-v="v"
                :data-k="k"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
    <Table :table="table" :normalTable="table && table.isNormal"></Table>
  </div>
</template>

<script>
import { colorArr, colorMixOpacity } from '../color/config.js';
import { getPie } from './common/tools.js';
import Table from '../Table';
import pieLineText from './pieLineText.vue';
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '单'
    },
    table: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  components: { Table, pieLineText },
  data() {
    return {
      colorArr,
      colorMixOpacity,
      pathArr: [],
      pathArr2: [],
      pathHover: [],
      textDis: 65,
      a: 120, // 长轴
      b: 60 // 短轴
    };
  },
  methods: {},
  computed: {
    dealSeries0data() {
      return this.series0data.filter(i => i.value > 0);
    },
    svgHeight() {
      return Math.max(this.dealSeries0data.length * 30, 360);
    }
  },
  created() {
    const { a, b } = this;
    this.pathArr = getPie({
      data: this.dealSeries0data,
      axis: [a, b],
      pyDis: 5,
      height: a == b ? 0 : 10,
      heightDis: a == b ? 0 : 3
    });
    this.pathArr2 = getPie({
      data: this.dealSeries0data,
      axis: [a / 3, b / 3],
      pyDis: 5,
      heightDis: a == b ? 0 : 3
    });
  }
};
</script>

<style lang="scss" scoped>
.custom-pie {
  display: flex;
  justify-content: space-around;
  align-items: center;
  &-item {
    .p {
      transform: translateY(-10px);
      &-1 {
        font-size: 14px;
        color: #434343;
        line-height: 1;
      }
      &-2 {
        font-size: 24px;
        color: #434343;
        line-height: 1;
        margin-top: 22px;
      }
    }
  }
}
.svg {
  path {
    transition: all 0.3s;
  }
  &-content {
    transform: translate(80px, 100px);
    .custom-pie-item-block {
      cursor: pointer;
    }
    .surface-shadow {
      transform-origin: 120px 55px;
      transform: translateX(80px) translateY(25px);
    }
    .shodow {
      transform-origin: 120px 55px;
      &-1 {
        transform: scale(1.2) translateY(20px);
      }
      &-2 {
        transform: scale(1.2) translateY(10px);
      }
    }
  }
}
</style>
